(() => {
  const prepareCarousel = (wrapper) => {
    const title = wrapper.querySelector('.jdgm-carousel-title');
    if (title) {
      const currentTitle = title.textContent.trim();
      if (currentTitle && title.dataset.rxTitle !== currentTitle) {
        title.dataset.rxTitle = currentTitle;
      }
    }

    const rating = wrapper.querySelector('.jdgm-all-reviews-rating[data-score]');
    if (rating) {
      const score = Number.parseFloat(rating.dataset.score || '');
      if (Number.isFinite(score)) {
        rating.dataset.rxScore = score.toLocaleString('it-IT', {
          minimumFractionDigits: 1,
          maximumFractionDigits: 1
        });
      }
    }

    wrapper.querySelectorAll('.jdgm-carousel-item__reviewer-name-wrapper').forEach((reviewer) => {
      const name = reviewer.querySelector('.jdgm-carousel-item__reviewer-name')?.textContent?.trim() || '';
      const words = name.split(/\s+/).filter(Boolean);
      const initials = words.length > 1
        ? `${words[0][0]}${words[words.length - 1][0]}`
        : (words[0] || 'R').slice(0, 2);
      reviewer.dataset.initials = initials.toUpperCase();
    });

    const previous = wrapper.querySelector('.jdgm-carousel__left-arrow');
    const next = wrapper.querySelector('.jdgm-carousel__right-arrow');
    if (previous) {
      previous.setAttribute('role', 'button');
      previous.setAttribute('tabindex', '0');
      previous.setAttribute('aria-label', 'Recensione precedente');
    }
    if (next) {
      next.setAttribute('role', 'button');
      next.setAttribute('tabindex', '0');
      next.setAttribute('aria-label', 'Recensione successiva');
    }

    wrapper.dataset.rxCarouselReady = 'true';
  };

  const wrappers = new Map();
  const pending = new Set();
  let frame = null;
  const schedule = (wrapper) => {
    pending.add(wrapper);
    if (frame !== null) return;
    frame = requestAnimationFrame(() => {
      frame = null;
      pending.forEach((item) => { if (item.isConnected) prepareCarousel(item); });
      pending.clear();
    });
  };
  const register = (wrapper) => {
    if (wrappers.has(wrapper)) return;
    const observer = new MutationObserver(() => schedule(wrapper));
    observer.observe(wrapper, { childList: true, subtree: true, characterData: true });
    wrappers.set(wrapper, observer);
    schedule(wrapper);
  };
  const discover = (root) => {
    if (root.nodeType !== 1 && root.nodeType !== 9) return;
    if (root.matches?.('.jdgm-carousel-wrapper')) register(root);
    root.querySelectorAll('.jdgm-carousel-wrapper').forEach(register);
  };
  const cleanup = () => {
    wrappers.forEach((observer, wrapper) => {
      if (!wrapper.isConnected) {
        observer.disconnect();
        wrappers.delete(wrapper);
        pending.delete(wrapper);
      }
    });
  };

  const activateKeyboard = (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    const arrow = event.target.closest('.jdgm-carousel__left-arrow, .jdgm-carousel__right-arrow');
    if (!arrow) return;
    event.preventDefault();
    arrow.click();
  };

  document.addEventListener('keydown', activateKeyboard);
  const observer = new MutationObserver((records) => {
    let removed = false;
    records.forEach((record) => {
      removed ||= record.removedNodes.length > 0;
      // Widget-local observers already handle descendants of known carousels.
      if (record.target.closest?.('.jdgm-carousel-wrapper')) return;
      record.addedNodes.forEach(discover);
    });
    if (removed) cleanup();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
  discover(document);
})();
